// c:\xampp\htdocs\miners-market-main\pages\SupplierAnalyticsPage.js

import SupplierAnalytics from '../components/SupplierAnalytics.jsx';

export default function SupplierAnalyticsPage() {
    return (
        <div data-name="supplier-analytics-page" data-file="pages/SupplierAnalyticsPage.js" className="min-h-screen py-8">
            <div className="container mx-auto px-4">
                <h1 className="text-4xl font-bold text-white mb-8">Supplier Analytics</h1>
                <SupplierAnalytics />
            </div>
        </div>
    );
}

